import 'jquery';
import { FTScroller } from 'ftscroller';
import * as utils from './utils';

export class HorizontalScroll {

    /**
     * Add the scroller(s) around each selected element.
     * @param {string} selector a jquery selector
     * @param {object} options options object
     * @param {object} ftscrollerOptions a ftscrollerOptions object
     */
    wrap(selector, options, ftscrollerOptions) {
        var qElements = $(selector);
        var scrollerWrappers = [];

        if (qElements.length === 0) {
            console.error('[horizontalScroll.wrap()] Could not wrap; Parameter 1 did not match any elements or was undefined.');
            return;
        }

        qElements.each(function (idx, element) {
            var qElement = $(element);
            var scrollerWrapper = document.createElement('div');
            qElement.after(scrollerWrapper)
                .detach()
                .appendTo(scrollerWrapper);

            scrollerWrappers.push(scrollerWrapper);
        });

        this.inject(scrollerWrappers, options, ftscrollerOptions);
    }

    /**
     * Add the scroller(s) around the children of each selected element.
     * @param {string} selector a jquery selector
     * @param {object} options options object
     * @param {object} ftscrollerOptions a ftscrollerOptions object
     * @return {Array<object>} scrollers objects
     */
    inject(selector, options, ftscrollerOptions) {
        var qElements = $(selector);
        var scrollers = [];

        if (qElements.length === 0) {
            console.error('[window.unify.horizontalScroll.inject()] Could not inject; Parameter 1 did not match any elements or was undefined.');
            return;
        }

        var optionsDefault = {
            addButtons: false,
            addOverflowIndicators: true,
            overflowIndicatorColor: 'default',
            scrollDurationMs: 1400,
            externalButtonLocation: false,
            buttonAlignment: { left: 'default', right: 'default' }
        };
        var ftscrollerOptionsDefault = {
            scrollingY: false,
            scrollbars: false,
            bouncing: false,
            updateOnWindowResize: true,
            disabledInputMethods: { scroll: true }
        };

        options = $.extend(true, optionsDefault, options);
        ftscrollerOptions = $.extend(true, ftscrollerOptionsDefault, ftscrollerOptions);

        var that = this;
        qElements.each(function (idx, element) {
            var elementHasHorizontalScroll = $(element).children().hasClass('unify-horizontal-scroller-scrollerwrapper');
            if (!elementHasHorizontalScroll) {
                var scroller = that._addScrollerToElement(element, options, ftscrollerOptions);
                scrollers.push(scroller);
            }
        });

        return scrollers;
    }

    _addScrollerToElement(element, options, ftscrollerOptions) {

        var qElement = $(element);
        var qButtonOutsideLocation;

        qElement.addClass('unify-horizontal-scroller');

        if (options.externalButtonLocation) {
            qButtonOutsideLocation = $(options.externalButtonLocation).first();
        }
        if (options.addOverflowIndicators) {
            qElement.addClass('unify-use-overflow-indicators');
        }
        if (options.overflowIndicatorColor === 'alternate') {
            qElement.addClass('unify-overflow-indicators-background-alternate');
        }
        if (options.overflowIndicatorColor === 'highlight') {
            qElement.addClass('unify-overflow-indicators-background-highlight');
        }

        /* 1. remove children temporarily */
        var qChildren = qElement.children();
        qChildren.remove();

        /* 2. create wrapper for scroller */
        // Tip: The scroller wrapper provides an environment with known styles 
        // so the the buttons and scroller can be reliably positioned
        var elScrollerWrapper = document.createElement('div');
        var qScrollerWrapper = $(elScrollerWrapper);

        qScrollerWrapper.addClass('unify-horizontal-scroller-scrollerwrapper');

        /* 3. put together the children, scroller wrapper, and scrolled element */
        qElement.append(qScrollerWrapper);
        qScrollerWrapper.append(qChildren);

        /* 4. add the scroller between the scrollerwrapper and the children */
        var ftscroller = new FTScroller(elScrollerWrapper, ftscrollerOptions);

        /* 6. add buttons */
        // Tip: The buttons are inserted after the creation of the FTScroller, so they stay outside the scroller
        var buttons = {};
        if (options.addButtons) {
            buttons = this._addButtonsToScroller(ftscroller, element, qScrollerWrapper, qButtonOutsideLocation, options);
        }

        /* 5. add change listeners that update classes which show whether the scroller can be scrolled in a given direction, or not */
        this._initResponsesToScrollabilityChange(ftscroller, qElement, buttons, options);

        return ftscroller;
    }

    _addButtonsToScroller(ftscroller, element, qScrollerWrapper, qButtonOutsideLocation, options) {

        $(element).addClass('unify-use-overflow-buttons');

        var elButtonRight = document.createElement('button');
        var elButtonLeft = document.createElement('button');

        var elButtonRightAnchor = document.createElement('div');
        var elButtonLeftAnchor = document.createElement('div');

        elButtonRightAnchor.appendChild(elButtonRight);
        elButtonLeftAnchor.appendChild(elButtonLeft);

        $(elButtonRight).addClass('unify-button-carousel unify-horizontal-scroller-button-right');
        $(elButtonLeft).addClass('unify-button-carousel unify-horizontal-scroller-button-left');

        if (options.buttonAlignment.left === 'edge') {
            elButtonLeft.classList.add('unify-button-alignment--edge');
        } else if (options.buttonAlignment.left === 'edge-inside') {
            elButtonLeft.classList.add('unify-button-alignment--edge-inside');
        }
        if (options.buttonAlignment.right === 'edge') {
            elButtonRight.classList.add('unify-button-alignment--edge');
        } else if (options.buttonAlignment.right === 'edge-inside') {
            elButtonRight.classList.add('unify-button-alignment--edge-inside');
        }

        elButtonRightAnchor.classList.add('unify-horizontal-scroller-button-anchor');
        elButtonLeftAnchor.classList.add('unify-horizontal-scroller-button-anchor');

        if (qButtonOutsideLocation && qButtonOutsideLocation.length > 0) {

            qButtonOutsideLocation.before(elButtonLeftAnchor);
            qButtonOutsideLocation.after(elButtonRightAnchor);
        } else {
            qScrollerWrapper.prepend(elButtonLeftAnchor);
            qScrollerWrapper.append(elButtonRightAnchor);
        }

        /* add listeners to the buttons */
        $(elButtonRight).on('click', function () {
            var pageWidth = qScrollerWrapper.outerWidth();
            ftscroller.scrollBy(pageWidth, 0, options.scrollDurationMs);
        });
        $(elButtonLeft).on('click', function () {
            var pageWidth = qScrollerWrapper.outerWidth();
            ftscroller.scrollBy(-pageWidth, 0, options.scrollDurationMs);
        });

        return {
            left: elButtonLeft,
            right: elButtonRight
        };
    }

    _initResponsesToScrollabilityChange(ftscroller, qElement, buttons, options) {
        var classCanScrollRight = 'unify-can-scroll-right';
        var classCanScrollLeft = 'unify-can-scroll-left';
        var classButtonShow = 'unify-horizontal-scroller-show-button';
        var hasExternalButtons = options.addButtons && options.externalButtonLocation;
        var qButtonLeft = $(buttons.left);
        var qButtonRight = $(buttons.right);

        utils.onFTScrollerScrollabilityChange(ftscroller, function (canScrollRight, canScrollLeft) {

            if (canScrollRight) {
                qElement.addClass(classCanScrollRight);

                if (hasExternalButtons) {
                    qButtonRight.addClass(classButtonShow);
                }
            } else {
                qElement.removeClass(classCanScrollRight);

                if (hasExternalButtons) {
                    qButtonRight.removeClass(classButtonShow);
                }
            }

            if (canScrollLeft) {
                qElement.addClass(classCanScrollLeft);

                if (hasExternalButtons) {
                    qButtonLeft.addClass(classButtonShow);
                }
            } else {
                qElement.removeClass(classCanScrollLeft);

                if (hasExternalButtons) {
                    qButtonLeft.removeClass(classButtonShow);
                }
            }
        });
    }

}
export var horizontalScroll = new HorizontalScroll();
